import { create } from 'zustand'
import { UserDto } from '../api/tenant/models/UserDto'
import { TenantDto } from '../api/tenant/models/TenantDto'

export type UserData = {
    user: UserDto
    tenant: TenantDto
}

interface UserStore {
    userData: UserData | null
    setUserData: (userData: UserData) => void
    clearUserData: () => void
    getUserDataOrThrow: () => UserData
}

export const useUserDataStore = create<UserStore>((set, get) => ({
    userData: null,
    setUserData: (userData) => set({ userData }),
    clearUserData: () => set({ userData: null }),
    getUserDataOrThrow: (): UserData => {
        const userData = get().userData
        if (!userData) {
            throw new Error('User data not found')
        }
        return userData
    },
}))

export const useSafeUserData = (): UserData => {
    const userData = useUserDataStore((state) => state.userData)

    if (!userData) {
        throw new Error('User data not found')
    }

    return userData
}
